import { AxiosResponse } from "axios";
import api from "./client";

// Unseen notifications (bell icon)
export const getUnseenNotifications = (
  tenant_id: string,
): Promise<AxiosResponse> =>
  api.get("/data-breach/notifications/unseen", { params: { tenant_id } });

// Mark a single notification as seen (omit notification_id to mark all seen).
// tenant_id is intentionally omitted — the backend resolves ownership from the
// access token across every tenant the principal is linked to, since a single
// unseen list can span notifications from more than one tenant.
export const markNotificationSeen = (
  notification_id?: string,
): Promise<AxiosResponse> =>
  api.post(
    "/data-breach/notifications/viewed",
    notification_id ? { notification_id } : {},
  );
